import { combineReducers } from 'redux';

// Reducers
import userReducer from './user-reducer';
import courseReducer from './course-reducer';
import commonReducer from './common-reducer';
import msgReducer from './msg-reducer';
import zoomReducer from './zoom-reducer';

// Combine Reducers
var reducers = combineReducers({
    userState: userReducer,
    courseState: courseReducer,
    commonState:commonReducer,
    msgState:msgReducer,
    zoomState:zoomReducer
  });
export default reducers;



/** WEBPACK FOOTER **
 ** ./src/client/app/reducers/index.js
 **/